var render, staticRenderFns
import script from "./casesDetail.vue?vue&type=script&lang=js&"
export * from "./casesDetail.vue?vue&type=script&lang=js&"
import style0 from "./casesDetail.vue?vue&type=style&index=0&id=776a1892&prod&lang=less&scoped=true&"
import style1 from "./casesDetail.vue?vue&type=style&index=1&id=776a1892&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776a1892",
  null
  
)

export default component.exports